export class TransferStoreWorkshopDetailImportModel {
  counter: number = 0;
  transferStoreWorkshopId: number = 0;
  consecutiveTransferStoreWorkshop: number = 0;
  articleCode: number = 0;
  articleName: string = "";
  storeCode: number = 0;
  quantity: number = 0;

  constructor(
    counter: number = 0,
    transferStoreWorkshopId: number = 0,
    consecutiveTransferStoreWorkshop: number = 0,
    articleCode: number = 0,
    articleName: string = "",
    storeCode: number = 0,
    quantity: number = 0
  ) {
    this.counter = counter;
    this.transferStoreWorkshopId = transferStoreWorkshopId;
    this.consecutiveTransferStoreWorkshop = consecutiveTransferStoreWorkshop;
    this.articleCode = articleCode;
    this.articleName = articleName;
    this.storeCode = storeCode;
    this.quantity = quantity;
  }
}